import m from "../../geodata/es2015/sanMarinoLow";
window.am4geodata_sanMarinoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sanMarinoLow.js
// module id = null
// module chunks = 